import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ShieldCheck } from 'lucide-react';
import { useContent } from '../context/ContentContext';
import Logo from './Logo';
import AnchorLink from './AnchorLink';

export const FOOTER_DEFAULTS = {
  description: "Laboratoire français de myciculture de précision. Mycélium d'élite, substrats stériles et équipement de culture pour passionnés exigeants.",
  legal: '© 2026 terrafungi.fr — cultiver l\'invisible',
};

const Footer = () => {
  const c = useContent('footer', FOOTER_DEFAULTS);
  return (
  <footer data-testid="site-footer" className="border-t border-white/8 bg-panel/40">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 md:grid-cols-4 lg:px-8">
      <div className="md:col-span-2">
        <Logo size={40} testid="footer-logo" />
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
          {c.description}
        </p>
        <p className="mt-4 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">
          <MapPin size={12} /> Salle blanche ISO-5 · France
        </p>
      </div>
      <div>
        <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-neon">Navigation</p>
        <ul className="space-y-2 text-sm text-slate-400">
          <li><Link to="/boutique" data-testid="footer-link-catalog" className="transition-colors hover:text-neon">Catalogue</Link></li>
          <li><AnchorLink id="manifeste" data-testid="footer-link-manifesto" className="transition-colors hover:text-neon">Manifeste</AnchorLink></li>
          <li><Link to="/contact" data-testid="footer-link-contact" className="transition-colors hover:text-neon">Contact</Link></li>
          <li><Link to="/blog" data-testid="footer-link-blog" className="transition-colors hover:text-neon">Blog & guides</Link></li>
          <li><Link to="/compte" data-testid="footer-link-account" className="transition-colors hover:text-neon">Mon compte</Link></li>
          <li><Link to="/admin" data-testid="footer-link-admin" className="transition-colors hover:text-cyber">Espace admin</Link></li>
        </ul>
      </div>
      <div>
        <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-neon">Protocole</p>
        <ul className="space-y-2 text-sm text-slate-400">
          <li className="flex items-center gap-2"><ShieldCheck size={13} className="text-neon" /> Paiement sécurisé Stripe</li>
          <li className="font-mono text-xs">Expédition 48 h · Suivi colis</li>
          <li className="font-mono text-xs">Livraison offerte dès 60 €</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/5 py-6">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-4 sm:flex-row sm:justify-between sm:px-6 lg:px-8">
        <p className="text-center font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">
          {c.legal}
        </p>
        <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">
          <li><Link to="/mentions-legales" data-testid="footer-link-legal" className="transition-colors hover:text-neon">Mentions légales</Link></li>
          <li><Link to="/confidentialite" data-testid="footer-link-privacy" className="transition-colors hover:text-neon">Confidentialité</Link></li>
        </ul>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
